
import { defineComponent, ref } from "vue";
import { getAllContainer } from "@/service/container.service";
import { Parameter } from "@/types/parameter.type";
import { Container } from "@/types/container.type";
import { getParameter } from "@/service/parameter.service";
import { FormInstance, ElForm, ElMessage } from "element-plus";
import { UploaderDataFilter, TrainingData } from "@/types/trainingData.type";
import { updateTmoaString } from "@/service/trainingData.service";

export default defineComponent({
  components: {},
  props: {
    checked: { type: Boolean },
  },
  setup() {
    const ruleFormRef = ref<FormInstance>();
    const originList = [
      {
        value: "CONTROL_ALGAS",
        label: "CONTROL DE ALGAS (SUPERFICIE)",
      },
      {
        value: "SCADA",
        label: "SCADA",
      },
      {
        value: "LABORATORIO",
        label: "LABORATORIO",
      },
      {
        value: "AQUACORP",
        label: "AQUACORP",
      },
      {
        value: "MULTIPARAMETRICA",
        label: "MULTIPARAMÉTRICA",
      },
      {
        value: "DUERO",
        label: "DUERO",
      },
      {
        value: "SONDA_DQO",
        label: "SONDA DQO",
      },
      {
        value: "SCRAPPING",
        label: "SCRAPPING",
      },
      {
        value: "SINTETICO",
        label: "SINTÉTICO",
      },
      {
        value: "OTRO",
        label: "OTRO",
      },
    ];

    originList.sort((a, b) => a.label.localeCompare(b.label));
    return { originList, ruleFormRef };
  },
  data() {
    return {
      customText: ref(""),
      uploaderDataFilter: {} as UploaderDataFilter, //- Obj. del formulario
      file: [] as Array<{ name: string; url: string | ArrayBuffer | null | undefined }>,
      containers: [] as Container[],
      parameters: [] as Parameter[],
      rules: {
        samplingPoint: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: blur,
          },
        ],
        origin: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: blur,
          },
        ],
        dataFile: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: blur,
          },
        ],
      },

      jsonObj: "" as any | undefined,
    };
  },
  async mounted() {
    this.containers = await getAllContainer();
    this.containers.sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""));
    this.parameters = (await getParameter(undefined, undefined)).data;
  },
  methods: {
    async logFormData() {
      const data = await updateTmoaString(
        this.uploaderDataFilter.container.id,
        this.uploaderDataFilter.samplingPointType,
        this.uploaderDataFilter.origin,
        this.customText
      );
      if (data.affected >= 1) {
        ElMessage.success(this.$t("success.action"));
      } else {
        ElMessage.error(this.$t("error.any"));
      }
    },
  },
  watch: {
    "uploaderDataFilter.container": {
      handler(newVal) {
        if (newVal?.containerType?.samplingPointType) {
          newVal.containerType.samplingPointType.sort((a: { name: any }, b: { name: any }) =>
            (a.name ?? "").localeCompare(b.name ?? "")
          );
        }
      },
      immediate: true,
      deep: true,
    },
  },
});
